import { useEffect, useRef } from "react"
import { getFirebaseConfig } from '../lib'

const { isprod } = getFirebaseConfig()

export default function Fleet({ props, onSuccess, onError, onInvalid }) {
  console.log('props', JSON.stringify(props))
  const {
      firstName,
			lastName,
			accountName,
			address, 
			amount,
      payWithVoyager,
      fleetToken,
  } = props
  var cardType = 'Wex'
  if (payWithVoyager) cardType = 'Voyager'
  console.log('fleetToken', fleetToken)
  const url = './fleet.html?cardType=' + cardType + '&firstName=' + firstName + '&lastName=' + lastName + '&company=' + accountName + '&address=' + address + '&isProd=' + isprod
	// const urltemp = './fleettest.html?firstName=' + firstName + '&lastName=' + lastName + '&company=' + accountName + '&address=' + address
	const iframeRef = useRef(null)

  useEffect(() => {
	
		function onLoad() {
			console.log("firing key")
			try {
				iframeRef.current.contentWindow.postMessage(
          { key: fleetToken, amount: amount },
				//{ key: "79622500-62BC-47E1-9002-BA751F96BB79", amount: amount },
				"*" // ideally specify exact origin for security
				)
			} catch (err) {
				console.error('error', err)
			}
      
    }

		function handleMessage(event) {
      if (event.data.type === "vaultSuccess") {
        console.log("Payload:", event.data.payload, event.data.payload.vaultId)
				onSuccess(event.data.payload.vaultId)
      }
			if (event.data.type === "vaultError") {
        console.log("Error:", event.data.payload )
				onError(event.data.payload)
      }
			if (event.data.type === "vaultInvalid") {
        console.log("Invalid:", event.data.payload, event.data.payload)
				onInvalid(event.data.payload)
      }
    }

    const iframeEl = iframeRef.current
    iframeEl.addEventListener("load", onLoad)
		console.log("added iframe listener:")
    window.addEventListener("message", handleMessage)

    // Cleanup listener on unmount
    return () => {
			iframeEl.removeEventListener("load", onLoad)
      window.removeEventListener("message", handleMessage)
    }
  }, [])

  return (
    <div>
      <iframe ref={iframeRef} width="534" height="1000" src={url} />
    </div>

  )
}